import { render, staticRenderFns } from "./SwiBanner.vue?vue&type=template&id=de0c6a2a&scoped=true"
import script from "./SwiBanner.vue?vue&type=script&lang=js"
export * from "./SwiBanner.vue?vue&type=script&lang=js"
import style0 from "./SwiBanner.vue?vue&type=style&index=0&id=de0c6a2a&prod&scoped=true&lang=scss"
import style1 from "./SwiBanner.vue?vue&type=style&index=1&id=de0c6a2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de0c6a2a",
  null
  
)

export default component.exports